import {HttpError} from '@hconnect/common/types'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useSnackbar} from 'notistack'

import {Api} from '../../../api'
import {settingsQueryClient} from '../../common/providers'
import {QueryKey as SignalsKey} from '../components/SignalList/api/useGetSignals'

export const useDeleteSignal = (successCb?: () => void) => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar()

  return useMutation({
    mutationFn: async (sensorId: string) => {
      const path = `/upm/signal/${sensorId}`
      return (await Api.axiosInstance.delete(path)).data
    },
    onSuccess: async () => {
      await settingsQueryClient.invalidateQueries({
        queryKey: ['upmStructure'],
        exact: false
      })
      await settingsQueryClient.invalidateQueries({queryKey: [SignalsKey], exact: false})

      enqueueSnackbar('Signal deleted successfully', {
        variant: 'success',
        autoHideDuration: 2500,
        preventDuplicate: true,
        onClick: () => closeSnackbar()
      })
      successCb?.()
    },
    onError: (error: AxiosError<HttpError>) => {
      enqueueSnackbar(`Signal could not be deleted: ${error.message}`, {
        variant: 'error',
        preventDuplicate: true,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClick: () => closeSnackbar()
      })
    }
  })
}
